import React from "react";

import { useTheme } from "styled-components";

import { Caption, Flex, ParagraphMd } from "@olist/design-system";

interface IReasonCardProps {
  description: string;
  label: string;
  onClick: () => void;
  icon: JSX.Element;
}

export function ReasonCard({
  description,
  icon,
  label,
  onClick,
}: IReasonCardProps) {
  const theme = useTheme();

  return (
    <Flex
      as="button"
      border="none"
      width="100%"
      backgroundColor={theme.background?.alternate || "#EFF0F8"}
      borderRadius="8px"
      padding="16px"
      marginBottom="8px"
      onClick={onClick}
      cursor="pointer"
      textAlign="left"
      color={theme.text?.primary}
      style={{
        transition: "background 0.2s, color 0.2s",
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        marginRight="16px"
        borderRadius="circle"
        backgroundColor={theme.background?.primary || "#fff"}
        width="52px"
        height="52px"
      >
        {icon}
      </Flex>
      <Flex flexDirection="column" justifyContent="center">
        <ParagraphMd bold margin={0} color={theme.text?.primary}>
          {label}
        </ParagraphMd>
        <Caption margin={0} color={theme.text?.secondary}>
          {description}
        </Caption>
      </Flex>
    </Flex>
  );
}
